import React from 'react';

class GridForm extends React.Component {
    render () {
        return (
            <div {...this.props} className={['component-grid-form', this.props.className || ''].join(' ')}>
                {this.props.children}
            </div>
        )
    }
}

export default GridForm;



// WEBPACK FOOTER //
// ./web-app/components/grid-form.jsx